import { render, staticRenderFns } from "./PageNotFoundViews.vue?vue&type=template&id=1fba2271&scoped=true"
import script from "./PageNotFoundViews.vue?vue&type=script&lang=js"
export * from "./PageNotFoundViews.vue?vue&type=script&lang=js"
import style0 from "./PageNotFoundViews.vue?vue&type=style&index=0&id=1fba2271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba2271",
  null
  
)

export default component.exports